import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

import { FormHandles, Scope } from '@unform/core'
import {
  AutenticacaoContainer,
  Botao,
  Breadcrumb,
  Cabecalho,
  Carregando,
  ErroLayoutContainer,
  FormUnform,
  IconeBack,
  InputUnform,
  Link,
  Modal,
  ModalRef,
  SelectOpcao,
  SelectUnform,
  Spacer
} from 'src/componentes'
import { SELECT_PAISES } from 'src/dados-estaticos/paises'
import { Conteudo } from 'src/paginas/ipgs/split-pagamento/cadastro/styles'
import {
  ContainerCheio,
  ContainerGrande,
  ContainerMedio,
  ContainerPequeno,
  Linha
} from 'src/paginas/matricula/styles'
import { RotasAluno } from 'src/rotas/aluno'
import { Api } from 'src/servicos'
import { ModalidadeCurso, PaisResidencia } from 'src/tipos'

import { ContainerInformacoes } from '../requerimentos-solicitados/style'
import { schema } from './schema'
import {
  SubMenu,
  Container,
  ContainerLink,
  ContainerBotoes,
  ContainerMain
} from './style'

export const PaginaCertificadoImpresso: React.FC = () => {
  const history = useHistory()
  const formRef = useRef<FormHandles>(null)
  const modalDeCancelamentoRef = useRef<ModalRef>(null)
  const [carregando, definirCarregando] = useState<boolean>(false)
  const [turmas, definirTurmas] = useState<SelectOpcao[]>()
  const [modalidade, definirModalidade] = useState<ModalidadeCurso>()
  const [pais, definirPais] = useState<string>(PaisResidencia.Brasil)
  const [turmaSelecionada, definirTurmaSelecionada] = useState<string>()

  const { usuario } = AutenticacaoContainer.useContainer()

  const [pronto, definirPronto] = useState<boolean>(false)

  const obterDadosTurmas = async () => {
    try {
      definirPronto(false)
      const turmas = await Api.ObterTurmasAluno()

      const turmasFormatado = turmas?.data?.turmas?.map(e => {
        return {
          id: e?.id,
          texto: e?.nome,
          modalidade: e?.modalidade,
          matriculaId: e?.matriculaId
        }
      })

      definirTurmas(turmasFormatado)
      definirPronto(true)
    } catch (error) {
      definirPronto(true)
    }
  }

  const acaoSucesso = async (dadosFormulario: any) => {
    definirCarregando(true)
    try {
      const { turma, endereco } = dadosFormulario

      await Api.CriarRequerimentoCertificadoImpresso(
        turma,
        endereco,
        turmaSelecionada
      )

      toast('Requerimento criado com sucesso!', {
        type: 'success'
      })
      history.push(
        `${RotasAluno.CertificadoImpressoPagamento}/${turmaSelecionada}`
      )
    } catch (error) {
    } finally {
      definirCarregando(false)
    }
  }

  const buscarCep = async (cep: string) => {
    if (pais !== PaisResidencia.Brasil) {
      return
    }

    const endereco = await Api.BuscarCep(cep)

    if (endereco) {
      formRef.current?.setFieldValue('endereco.bairro', endereco.bairro)
      formRef.current?.setFieldValue('endereco.logradouro', endereco.logradouro)
      formRef.current?.setFieldValue('endereco.cidade', endereco.cidade)
      formRef.current?.setFieldValue('endereco.uf', endereco.uf)
      formRef.current?.setFieldValue('endereco.numero', endereco.numero)
      document.getElementById('ipt_numero')?.focus()
    } else {
      formRef.current?.setFieldValue('endereco.bairro', '')
      formRef.current?.setFieldValue('endereco.logradouro', '')
      formRef.current?.setFieldValue('endereco.cidade', '')
      formRef.current?.setFieldValue('endereco.uf', '')
      formRef.current?.setFieldValue('endereco.complemento', '')
      formRef.current?.setFieldValue('endereco.numero', '')
    }
  }

  useEffect(() => {
    obterDadosTurmas()
  }, [])

  return (
    <Container>
      <ContainerLink>
        <Link
          texto="Voltar"
          icone={IconeBack}
          acaoVoltar={() => history.goBack()}
        />
      </ContainerLink>
      <ContainerMain>
        <Cabecalho>
          <Breadcrumb
            titulo="Solicitação de Certificado Impresso"
            atalhos={[
              {
                texto: 'Requerimentos'
              },
              {
                texto: 'Certificado Impresso'
              }
            ]}
          />
        </Cabecalho>
        <Conteudo>
          {!pronto ? (
            <Carregando texto="Carregando dados..." />
          ) : turmas && turmas.length > 0 ? (
            <FormUnform
              schema={schema}
              ref={formRef}
              acaoSucesso={acaoSucesso}
              dadosIniciais={{ nome: usuario.nome }}
            >
              <Container>
                <Linha>
                  <ContainerCheio>
                    <InputUnform
                      name="nome"
                      label="Nome Completo"
                      maxLength={200}
                      obrigatorio
                      disabled
                      style={{ textTransform: 'uppercase' }}
                    />
                  </ContainerCheio>
                </Linha>
                <Linha>
                  <ContainerCheio>
                    <SelectUnform
                      id="slct_turma"
                      name="turma"
                      label="Turma"
                      obrigatorio
                      opcoes={turmas}
                      valorAlterado={(opcaoSelecionada: SelectOpcao) => {
                        const turmaSelecionada = turmas.find(
                          t => t.id === opcaoSelecionada.id
                        )
                        if (turmaSelecionada) {
                          definirModalidade(
                            ModalidadeCurso[turmaSelecionada.modalidade]
                          )
                          definirTurmaSelecionada(turmaSelecionada.matriculaId)
                        }
                      }}
                    />
                  </ContainerCheio>
                </Linha>
                <SubMenu>Endereço</SubMenu>
                <Scope path="endereco">
                  <Linha>
                    <ContainerMedio>
                      <SelectUnform
                        id="slc_pais"
                        name="pais"
                        label="País"
                        placeholder="Selecione"
                        obrigatorio
                        opcoes={SELECT_PAISES}
                        valorAlterado={opcao =>
                          definirPais(opcao ? opcao.id : '')
                        }
                      />
                    </ContainerMedio>
                    <ContainerMedio>
                      <InputUnform
                        id="ipt_cep"
                        name="cep"
                        label="CEP"
                        obrigatorio={pais === PaisResidencia.Brasil}
                        mascara="99999-999"
                        onBlur={event => buscarCep(event.target.value)}
                      />
                    </ContainerMedio>
                  </Linha>
                  <Linha>
                    <ContainerGrande>
                      <InputUnform
                        id="ipt_logradouro"
                        name="logradouro"
                        label="Logradouro"
                        obrigatorio
                        maxLength={200}
                      />
                    </ContainerGrande>
                    <ContainerPequeno>
                      <InputUnform
                        id="ipt_numero"
                        name="numero"
                        label="Número"
                        obrigatorio
                        maxLength={10}
                      />
                    </ContainerPequeno>
                  </Linha>
                  <Linha>
                    <ContainerMedio>
                      <InputUnform
                        id="ipt_complemento"
                        name="complemento"
                        label="Complemento"
                        maxLength={200}
                      />
                    </ContainerMedio>
                    <ContainerMedio>
                      <InputUnform
                        id="ipt_bairro"
                        name="bairro"
                        label="Bairro"
                        obrigatorio
                        maxLength={200}
                      />
                    </ContainerMedio>
                  </Linha>
                  <Linha>
                    <ContainerMedio>
                      <InputUnform
                        id="ipt_cidade"
                        name="cidade"
                        label="Cidade"
                        obrigatorio
                        maxLength={200}
                      />
                    </ContainerMedio>
                    <ContainerMedio>
                      <InputUnform
                        id="ipt_uf"
                        name="uf"
                        label="UF"
                        obrigatorio
                      />
                    </ContainerMedio>
                  </Linha>
                </Scope>
                <Spacer padding="20px 0px" />
              </Container>
              <ContainerBotoes>
                <Botao
                  type="button"
                  id="btn-cancelar"
                  texto="Cancelar"
                  tema="Secundario"
                  onClick={() => modalDeCancelamentoRef?.current?.abrir()}
                />
                <Botao type="submit" id="btn-submit" texto="Avançar" />
              </ContainerBotoes>
            </FormUnform>
          ) : (
            <>
              <ContainerInformacoes>
                <p>
                  Olá, parece que você ainda não tem nenhum curso finalizado.
                </p>
                <p>
                  Assim que você atingir 100% de progresso na sua sala de aula e
                  estiver com as notas acima da média você vai estar apto a
                  solicitar seu certificado impresso!
                </p>
                <p>Equipe iPGS.</p>
              </ContainerInformacoes>
              <ContainerBotoes>
                <Botao
                  type="button"
                  id="btn-voltar"
                  texto="Voltar"
                  tema="Secundario"
                  onClick={() => history.goBack()}
                />
              </ContainerBotoes>
            </>
          )}
          <Modal
            ref={modalDeCancelamentoRef}
            backdrop
            id="modal-de-cancelamento"
            titulo="Deseja cancelar?"
            acaoPrimaria={{
              titulo: 'Sim',
              tipo: 'button',
              acao: () => history.goBack()
            }}
            acaoSecundario={{
              titulo: 'Não',
              tipo: 'button',
              acao: () => modalDeCancelamentoRef?.current?.fechar()
            }}
          >
            <p>Selecione uma opção</p>
          </Modal>
        </Conteudo>
      </ContainerMain>
    </Container>
  )
}

export default (): JSX.Element => (
  <ErroLayoutContainer.Provider>
    <PaginaCertificadoImpresso />
  </ErroLayoutContainer.Provider>
)
